import styled from "styled-components";

export const StyledOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;

  background-color: rgba(0, 0, 0, 0.4);
  transition: all 300ms ease-out;
`;

export const StyledModalContainer = styled.div`
  z-index: 1000;
  position: absolute;
  top: 30px;
  right: 30px;
  bottom: 30px;
  left: 30px;

  display: flex;
  flex-direction: column;

  width: auto;

  border-radius: 5px;
  background-color: white;
`;

export const StyledModalHeader = styled.div`
  position: relative;

  display: flex;
  align-items: center;

  min-height: 70px;
  border-bottom: 1px solid rgba(15, 15, 15, 0.05);
  padding: 0 20px 0 30px;

  background-color: white;
  border-radius: 5px 5px 0 0;
`;
